import React from "react";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { Grid } from "@mui/material";
import { useFormik } from "formik";
import {
  CustomFormLabel,
  CustomTextField,
} from "../../../../components/formsComponents";
import { useDispatchWrapper } from "../../../../hooks";
import { useBillingCompanyContext } from "../../../../providers";
import { upsertLeadSourceAsync } from "../../../../redux/leads/leadsActions";
import {
  ILeadSource,
  initialLeadSource,
} from "../../../../redux/leads/leads.types";

interface ICreateLeadSourceDialogProps {
  open: boolean;
  onClose: () => void;
  initialSourceName?: string;
  onSuccess?: (leadSource: ILeadSource) => void;
}

export const CreateLeadSourceDialog: React.FC<ICreateLeadSourceDialogProps> = (
  props
) => {
  const { open, onClose, initialSourceName = "", onSuccess } = props;
  const dispatch = useDispatchWrapper();
  const companyOutlet = useBillingCompanyContext();

  const { values, errors, handleChange, handleSubmit } = useFormik<ILeadSource>(
    {
      initialValues: {
        ...initialLeadSource,
        source_name: initialSourceName,
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        status: "ACTIVE",
      },
      validate: (values) => {
        const errors: { source_name?: string } = {};
        if (!values.source_name || values.source_name.trim() === "") {
          errors.source_name = "Source name is required";
        }
        return errors;
      },
      onSubmit: (values) => {
        const payload: ILeadSource = {
          lead_source_uuid: values.lead_source_uuid || "",
          source_name: values.source_name,
          source_name_link: values.source_name_link,
          company_outlet_uuid: values.company_outlet_uuid,
          status: values.status,
        };

        dispatch(
          upsertLeadSourceAsync(payload, (isSuccess, data) => {
            if (isSuccess && data) {
              onSuccess?.(data);
              onClose();
            }
          })
        );
      },
    }
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Add New Lead Source"
      size="sm"
      contentWrappedWithForm={{ onSubmit: handleSubmit }}
      actions={[
        {
          variant: "outlined",
          label: "Cancel",
          type: "button",
          onClick: onClose,
        },
        {
          variant: "contained",
          label: "Save",
          type: "submit",
        },
      ]}
    >
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={12}>
          <CustomFormLabel>Source Name *</CustomFormLabel>
          <CustomTextField
            id="source_name"
            name="source_name"
            placeholder="Enter source name"
            fullWidth
            value={values.source_name || ""}
            onChange={handleChange}
            error={!!errors.source_name}
            helperText={errors.source_name}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomFormLabel>Source Link</CustomFormLabel>
          <CustomTextField
            id="source_name_link"
            name="source_name_link"
            placeholder="Enter source link (e.g. https://facebook.com)"
            fullWidth
            value={values.source_name_link || ""}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};
